import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import BoxSections from './BoxSections'
import ContentDiv from './ContentDiv'
import HeroSections from './HeroSections'
import KeyFeature from './KeyFeature'
import { Helmet } from 'react-helmet'
export default function MobileDevPageIndex(props) {
    const { nft_slug } = useParams()
    // =========================== scroll To Top default =========================
    useEffect(() => {
        props.demo('top')
    }, [nft_slug])
    // =========================== scroll To Top default =========================
    return (
        <>
            <Helmet>
                <title>Mobile Development Company – Infograins</title>
                <meta name="description" content="Infograins is an enterprise level mobile development company. Our skilled mobile developers specialized in developing unique, feature-rich, high-performing mobile experiences." />
            </Helmet>
            <HeroSections />
            <BoxSections />
            <ContentDiv />
        </>
    )
}
